<template>
    <div class="weddingrecords">
        <z-title title="婚庆预定记录" ref="title"></z-title>
        <el-card ref="search" class="content1">
            <div class="flex-n fac ">
                <el-input
                        size="medium"
                        class="ele-input mr-10"
                        placeholder="输入姓名"
                        maxlength="20"
                        clearable
                        title="输入要搜索的姓名"
                        prefix-icon="el-icon-search"
                        v-model="customName">
                </el-input>
                <el-input
                        size="medium"
                        class="ele-input mr-10"
                        type="number"
                        clearable
                        placeholder="输入电话号码"
                        title="输入电话号码"
                        prefix-icon="el-icon-search"
                        maxlength="11"
                        v-model="phone">
                </el-input>
                <div class="textnowrap">场地：</div>
                <want-house  clearable class="mr-10" size="medium" v-model="houseId" placeholder="请选择"></want-house>
                <div class="textnowrap">套餐类型：</div>
                <wedding-package   clearable class="mr-10" size="medium" v-model="packageId" placeholder="请选择"></wedding-package>
            </div>
            <div class="flex-n fac  mt-10">
                <div class="textnowrap">预定日期：</div>
                <el-date-picker
                        size="medium"
                        class="mr-10 date"
                        v-model="dateRange"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                >
                </el-date-picker>
                <div class="textnowrap">下单日期：</div>
                <el-date-picker
                        size="medium"
                        class="mr-10 date"
                        v-model="orderDateRange"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                >
                </el-date-picker>
                <el-button type="primary" class="ele-btn2" @click="searchWeddingOrder">查询</el-button>
            </div>
        </el-card>
        <el-card class="mt-10">
            <el-table
                    header-cell-class-name="headerrow"
                    cell-class-name="cellclass"
                    :height="height+'px'"
                    highlight-current-row
                    :data="dataList"
                    v-loading="loading"
                    element-loading-text="列表刷新中"
                    style="width: 100%">
                <el-table-column
                        fixed
                        align="center"
                        prop="customName"
                        label="客户姓名"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="phone"
                        label="电 话"
                        min-width="120"
                        align="center">
                </el-table-column>
                <el-table-column
                        label="预定日期"
                        width="190"
                        align="center">
                    <template  slot-scope="scope">
                        {{scope.row.orderDate}} {{scope.row.activityBeginTime}}~{{scope.row.activityEndTime}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="houseName"
                        label="预定场地"
                        min-width="120"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="orderNumber"
                        label="预定桌数"
                        min-width="120"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="packageName"
                        label="预定套餐"
                        min-width="140"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="maleName"
                        label="新郎姓名"
                        min-width="100"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="femaleName"
                        label="新娘姓名"
                        min-width="100"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="beginTime"
                        label="典礼开始时间"
                        min-width="120"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="weddingPackageName"
                        label="婚庆套餐"
                        min-width="120"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="createUserName"
                        label="接待人员"
                        width="120"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="createUserPhone"
                        label="接待电话"
                        width="120"
                        align="center">
                </el-table-column>
                <el-table-column
                        label="应收款"
                        width="120"
                        align="center">
                    <template slot-scope="scope">
                        {{scope.row.weddingMoney||0}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="downPayment"
                        label="婚庆定金"
                        min-width="100"
                        align="center">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="130"
                        align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.orderConfirmState!='02'">
                            <el-select style="padding: 5px 0" value="" class="ele-select mr-10" size="mini"
                                       placeholder="选择操作"
                                       @change="changeTodo(scope.row.orderId,scope.row.id,$event)"  @visible-change="getSelectList(scope.row,$event)">

                                <el-option
                                        v-for="item,index in todoOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>

                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!--分页-->
            
            <pagination :current-page="currentPage" :page-size="pageSize" :total="total"   @sizeChange="handleSizeChange"
                        @currentChange="handleCurrentChange"></pagination>

        </el-card>
        <!--新增编辑查看-->
        <!--新增后状态改为编辑-->
        <!--上半部分内容读取不变，下半部分变化，新增编辑和表单-->
        <el-dialog :visible.sync="showdialog"   class="doedit" width="880px" :close-on-click-modal="false">
            <div slot="title">
                <z-title :title="editstate+'预定'"></z-title>
            </div>
            <div class="plr-20 content lh-30">
                <orderbase :info="info"></orderbase>
                <template v-if="!showWeddinginfo&&editstate!='查看'">
                    <el-divider class="title" content-position="left">{{editstate}}</el-divider>
                    <el-form label-width="100px" :model="weddingData" :rules="rules" class="plr-20" size="medium"
                             ref="weddingData">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="新郎姓名" :show-message="false" prop="maleName">
                                    <el-input maxlength="8" v-model="weddingData.maleName"
                                              placeholder="请输入新郎姓名"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="新娘姓名" :show-message="false" prop="femaleName">
                                    <el-input maxlength="8" v-model="weddingData.femaleName"
                                              placeholder="请输入新娘姓名"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="手机号码" prop="phoneMale">
                                    <el-input  type="number"  v-model="weddingData.phoneMale"
                                              placeholder="请输入手机号码"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="其他手机号码" prop="phoneFemale">
                                    <el-input  type="number" v-model="weddingData.phoneFemale"
                                              placeholder="请输入其他手机号码"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="典礼开始时间" prop="beginTime">
                                    <el-time-picker
                                            class="w-270"
                                            value-format="HH:mm" format="HH:mm"
                                            :default-value="info.activityBeginTime"
                                            :picker-options="{
      selectableRange:info.activityBeginTime+'-'+info.activityEndTime
    }"
                                            v-model="weddingData.beginTime"
                                            placeholder="选择典礼开始时间">
                                    </el-time-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="婚庆套餐"  prop="weddingPackage">
                                    <wedding-package type="object" class="w-270" size="medium" clearable
                                                     v-model="weddingData.weddingPackage"
                                                     placeholder="请选择婚庆套餐"></wedding-package>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="额外项目" prop="exItemMoney">
                                    <div class="flex-n w-270">
                                        <el-input-number class="mr-10" disabled v-model="weddingData.exItemMoney"
                                                         :controls="false" :precision="2" :step="0.1"
                                                         controls-position="right" :min="0"
                                                         :max="9999999999"></el-input-number>
                                        <el-button type="primary" @click="lookextra">编辑查看</el-button>
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="婚庆价格" :show-message="false" prop="orderMoney">
                                    <el-input placeholder="请输入婚庆价格"    class="w-270" v-model="weddingData.orderMoney"
                                              v-number="{precision:2}">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="婚庆定金" :show-message="false" prop="downPayment">
                                    <el-input placeholder="请输入婚庆定金"    class="w-270" v-model="weddingData.downPayment"
                                              v-number="{precision:2}">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="接待人员" prop="createUserName">
                                    <el-input maxlength="64" disabled v-model="info.createUserName"
                                              placeholder="请输入婚庆接待人员"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col>
                                <el-form-item label="备 注" prop="remark">
                                    <el-input type="textarea" rows="6" show-word-limit v-model="weddingData.remark"
                                              resize="none"
                                              maxlength="512"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-form-item class="mt-10 flex-n fje">
                            <el-button type="primary" @click="submitForm('weddingData')" :loading="addloading">{{addloading?'保存中':'确 定'}}</el-button>
                            <el-button @click="showdialog=false">取 消</el-button>
                        </el-form-item>
                    </el-form>
                </template>
                <weddingbase v-if="showWeddinginfo" :info="wedinfo"></weddingbase>
                <el-row v-if="editstate=='查看'">
                    <div class="flex-n fjc mb-10 mt-10">
                        <el-button type="primary" @click="showdialog=false;showWeddinginfo=false">关 闭</el-button>
                    </div>
                </el-row>
            </div>

        </el-dialog>
        <!---->
        <extra-list title="额外合计项目" v-model="weddingData.extraTree" :is-wedding="true" :visible.sync="showextra"
                    @getTotal="getTotal"></extra-list>
    </div>
</template>

<script>
    import ZTitle from "../../components/ZTitle";
    import ElFormItem from "element-ui/packages/form/src/form-item";
    import WantHouse from "../../components/data/wantHouse";
    import WeddingPackage from "../../components/data/weddingPackage";
    import ExtraList from "../component/extra";
    import Orderbase from "../component/orderbase";
    import Weddingbase from "../component/weddingbase";
    import Pagination from "../../components/pagination/pagination";


    export default {
        components: {

            Pagination,
            Weddingbase,
            Orderbase,
            ExtraList,
            WeddingPackage,
            WantHouse,
            ElFormItem,
            ZTitle
        },
        name: "weddingrecords",
        data() {
            var validatetel = (rule, value, callback) => {

                if(value&&value!=''&&value.length!=11){
                    return callback(new Error('请输入11位的有效手机号码'));
                }
                return callback();
            };
            return {
                addloading:false,
                loading: false,
                pageSize: 20,
                currentPage: 1,
                total: 0,
                height: 250,
                editstate: '新增',

                dataList: [],
                info: {},
                wedinfo: {},

                customName: '',
                phone: '',
                dateRange: [],
                orderDateRange:[],
                houseId: "",
                packageId: "",
                confirmStateText: "",
                weddingCustomName: "",
                beginTime: "",
                orderId: '',
                wedId: '',


                todoOptions: [],
                weddingData: {
                    "orderId": "",
                    "maleName": "",
                    "femaleName": "",
                    "phoneMale": "",
                    "phoneFemale": "",
                    "beginTime": "",
                    "weddingPackage": {},
                    "exItemMoney": '',//额外项目金额
                    "weddingItemsExs": [],
                    "extra": {},
                    "orderMoney": "",
                    "downPayment": "",
                    "remark": ""
                },
                rules: {
                    maleName: [{required: true, trigger: 'blur'}],
                    femaleName: [{required: true, message: '新娘姓名不能为空', trigger: 'blur'}],
                    phoneMale: [{validator: validatetel, trigger: 'change'}],
                    downPayment: [{required: true, trigger: 'blur'}],
                    orderMoney: [{required: true, trigger: 'blur'}]
                },
                showdialog: false,
                state: '1',//暂时使用得状态判断
                showWeddinginfo: false,
                showextra: false
            }
        },
        computed:{
            pickerOptions() {
                var that=this;
                return{
                    firstDayOfWeek: 1,
                    shortcuts: [
                        {
                            text: '今日',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '昨日',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24);
                                end.setTime(end.getTime() - 3600 * 1000 * 24);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '本周',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                var num=start.getDay();
                                if(num==0){
                                    num=7;
                                }
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * (num-1));
                                end.setTime(end.getTime() + 3600 * 1000 * 24 * (7-num));
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '上周',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                var num=start.getDay();
                                if(num==0){
                                    num=7;
                                }
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * (num+6));
                                end.setTime(end.getTime() - 3600 * 1000 * 24 * num);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '本月',
                            onClick(picker) {
                                const start = new Date();
                                var year=start.getFullYear(),month=start.getMonth()+1;
                                var startDate=new Date(year+'-'+month+'-1');
                                var length=that.$TM.getMonthArea().length-1;
                                var dd=that.$TM.getMonthArea()[length].dd;
                                var endDate= new Date(that.$TM.getMonthArea()[length-(dd<7?dd:0)].date);
                                console.log(startDate,endDate)
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                        {
                            text: '上月',
                            onClick(picker) {
                                const start = new Date();
                                console.log(that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1}))
                                var month=that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1})[15].mm,
                                    year=that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1})[15].yy;
                                var length=that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1}).length-1;
                                var dd=that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1})[length].dd;
                                var startDate=new Date(year+'-'+month+'-1');
                                var endDate= new Date(that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1})[length-(dd<7?dd:0)].date);
                                // console.log(startDate,endDate)
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        }
                    ]
                }
            },

        },
        watch: {
            'weddingData.weddingPackage': {
                deep: true,
                handler: function (newval, oldval) {
                    console.log(newval)
                    if (newval && newval.packageTypeCode) {
                        this.getSetmealList(newval.packageTypeCode);
                    }
                }
            },
            showdialog(newval, oldval) {
                console.log(this.editstate)
                if (!newval) {
                    this.showWeddinginfo = false;
                    if(this.editstate != '查看'){
                        this.$refs.weddingData.resetFields();
                    }
                }
            }
        },
        mounted() {
            setTimeout(()=>{
                this.height=document.body.offsetHeight -this.$refs.title.$el.offsetHeight-this.$refs.search.$el.offsetHeight - 200;
                console.log(this.height)
            },0)
            var date=this.$TM.getDayArea();
            var mm=date.mm,yy=date.yy;
            if(mm==12){
                mm=1;
                yy++;
            }
            var date2=new Date(new Date(this.$TM.getDayArea(yy,mm+1,1).date).getTime()-24*60*60*1000);            this.dateRange=[date.yy+'-'+date.mm+'-1',date2.getFullYear()+'-'+(date2.getMonth()+1)+'-'+date2.getDate()];
            this.getWeddingOrder();
        },
        methods: {
            //新增时获取默认定金
            getdownPayment() {
                this.$axios.get('config/baseByStoreId/' + this.$root.getStorage('storeId')).then(res => {
                    console.log('定金',res.data.orderDefaultMoney)
                    this.$set(this.weddingData, 'downPayment', res.data.orderDefaultMoney || 0);

                }).catch(err => {
                    this.$refs.message.error(err.msg);
                })
            },
            //获取套餐详情
            getSetmealList(id) {
                console.log(id)
                this.$axios.post('/foodPackage/foodPackageByIdAndType',{
                    "id": id,
                    "packageTypeCode": '02'
                }).then(res => {
                    console.log(res)
                    this.weddingData.weddingItemsExs = res.data.itemsWeddingTree||[];
                }).catch(err => {
                    this.$message.error(err.msg);
                })
            },
            //查询婚庆预定列表
            getWeddingOrder() {
                this.loading = true;
                this.$axios.post('/wedding/orderWeddingList', {
                    "storeId": this.$root.getStorage('storeId'),
                    "customName": this.customName,
                    "pageNum":this.currentPage,
                    "pageSize":this.pageSize,
                    "phone": this.phone,
                    "startTime": this.dateRange?this.dateRange[0]:'',
                    "endTime": this.dateRange?this.dateRange[1]:'',
                    "createTimeBegin": this.orderDateRange?this.orderDateRange[0]:'',
                    "createTimeEnd": this.orderDateRange?this.orderDateRange[1]:'',
                    "houseId": this.houseId,
                    "packageId": this.packageId,
                    "confirmStateText": this.confirmStateText,
                    "weddingCustomName": this.weddingCustomName,
                    "beginTime": this.beginTime
                }).then(res => {
                    console.log('婚庆预定列表', res);
                    var dataList = res.data.list;

                    for(var i in dataList){
                        var content='';
                        for(var j in  dataList[i].payTypes){
                            if(dataList[i].payTypes[j].payTypeCode=='01'){
                                content += (dataList[i].payTypes[j].orderCount||0) +'人、';
                            }
                            if( dataList[i].payTypes[j].payTypeCode=='02'){
                                content += (dataList[i].payTypes[j].orderCount||0) +'桌、';
                            }
                        }
                        if(content.substring(content.length-1,content.length)=='、'){
                            content=content.substring(0,content.length-1)
                        }
                        if(content!=''){
                            if(dataList[i].mainPayType=='03'){
                                dataList[i].orderNumber='包场('+ content +')'
                            }else{
                                dataList[i].orderNumber=content
                            }

                        }
                    }
                    this.dataList = dataList;
                    this.total = res.data.total;
                    this.loading = false;
                }).catch(err => {
                    this.$message.error(err.msg);
                    this.loading = false;
                })
            },
            //搜索
            searchWeddingOrder() {
                this.currentPage = 1;
                this.getWeddingOrder();
            },
            //添加提交
            addSubmit() {

                var weddata = this.weddingData;
                console.log(  weddata.extra,weddata.extra.itemsExTree)
                this.$axios.post('/wedding/orderWeddingAdd', {
                    "storeId": this.$root.getStorage('storeId'),
                    "orderId": this.orderId,
                    "maleName": weddata.maleName,
                    "femaleName": weddata.femaleName,
                    "phoneMale": weddata.phoneMale,
                    "phoneFemale": weddata.phoneFemale,
                    "beginTime": weddata.beginTime,
                    "packageName": weddata.weddingPackage.packageName,
                    "packageId": weddata.weddingPackage.packageTypeCode,
                    "exItemMoney": weddata.exItemMoney,//额外项目金额
                    "weddingItemsExs": weddata.weddingItemsExs,
                    "extra": weddata.extraTree.itemsExTree,
                    "orderMoney": weddata.orderMoney,
                    "downPayment": weddata.downPayment,
                    "remark": weddata.remark
                }).then(res => {
                    this.currentPage = 1;
                    this.getWeddingOrder();
                    this.$message.success('新增婚庆预定成功！');
                    this.showdialog = false;
                    this.addloading=false;
                }).catch(err => {
                    this.addloading=false;
                    this.$message.error(err.msg);
                })
            },
            //编辑提交
            editSubmit() {
                var weddata = this.weddingData;
                this.$axios.post('/wedding/orderWeddingUpdate', {
                    "storeId": this.$root.getStorage('storeId'),
                    "id":weddata.id,
                    "weddingOrderId": this.wedId,
                    "orderId": this.orderId,
                    "maleName": weddata.maleName,
                    "femaleName": weddata.femaleName,
                    "phoneMale": weddata.phoneMale,
                    "phoneFemale": weddata.phoneFemale,
                    "beginTime": weddata.beginTime,
                    "packageName": weddata.weddingPackage.packageName,
                    "packageId": weddata.weddingPackage.packageTypeCode,
                    "exItemMoney": weddata.exItemMoney,//额外项目金额
                    "weddingItemsExs": weddata.weddingItemsExs,
                    "extra": weddata.extraTree.itemsExTree,
                    "orderMoney": weddata.orderMoney,
                    "downPayment": weddata.downPayment,
                    "remark": weddata.remark
                }).then(res => {
                    this.addloading=false;
                    this.$message.success('编辑婚庆预定成功！');
                    this.getWeddingOrder();
                    this.showdialog = false;
                }).catch(err => {
                    this.addloading=false;
                    this.$message.error(err.msg);
                })
            },
            //验证表单
            submitForm(formName) {
                this.addloading=true;
                this.$refs[formName].validate((valid) => {
                    if (valid) {

                        if (this.editstate == '新增婚庆') {
                            this.addSubmit();
                        } else {
                            this.editSubmit();
                        }
                    } else {
                        this.addloading=false;
                        this.$message.error('表单填写有误');
                        return false;
                    }
                });
            },
            //下拉列表功能
            getSelectList(row,show){
                console.log(show)
                // (scope.row.id==null?((scope.row.orderConfirmState=='01'||scope.row.orderConfirmState=='02')?(scope.row.auth&&scope.row.auth.isDelete=='1'?(item.value==5):(item.value>5)):(scope.row.auth&&scope.row.auth.isDelete=='1'?(item.value==5||item.value==1):(item.value==1))):((scope.row.orderConfirmState=='01'||scope.row.orderConfirmState=='02')?(scope.row.auth&&scope.row.auth.isDelete=='1'?(item.value==5):(item.value>5)):(scope.row.auth&&scope.row.auth.isDelete=='1'?(item.value==5||item.value==2||item.value==4):(item.value==2||item.value==4))))||item.value==3"

                    if(show){
                    var todoOptions=[{
                        value: '1',
                        label: '新增婚庆'
                    }, {
                        value: '2',
                        label: '编辑婚庆'
                    }, {
                        value: '3',
                        label: '查看预定'
                    }, {
                        value: '4',
                        label: '复制婚庆'
                    }, {
                        value: '5',
                        label: '取消婚庆'
                    }
                    ];
                    if(row.id){//编辑，没有1
                        for(var i=0;i<todoOptions.length;i++){
                            if(todoOptions[i].value=='1'){
                                todoOptions.splice(i,1);
                                i--;
                            }
                        }
                    }else{//新增，没有2,3,4,5
                        for(var i=0;i<todoOptions.length;i++){
                            if(todoOptions[i].value!='1'){
                                todoOptions.splice(i,1);
                                i--;
                            }
                        }
                    }
                    //非当前登录人，没有编辑权限，只能查看 3
                    if(row.createUserCode!=this.$root.getStorage('info').userId&&this.$root.getStorage('menuAuth').isEditOther=='0'){
                        for(var i=0;i<todoOptions.length;i++){
                            if(todoOptions[i].value!='3'){
                                todoOptions.splice(i,1);
                                i--;
                            }
                        }
                    }
                    if(row.auth&&row.auth.isDelete!='1'){
                        for(var i in todoOptions){
                            if(todoOptions[i].value=='5'){
                                todoOptions.splice(i,1);
                                break;
                            }
                        }
                    }

                    this.todoOptions=todoOptions;
                }

            },
            changeTodo(orderid, wedid, data) {
                console.log(data,wedid)
                this.orderId = orderid;
                this.wedId = wedid;
                //上半部基本信息
                if(this.orderId)
                    this.$axios.get('/order/orderDetailById/' + orderid).then(res => {
                        this.info = res.data;
                    }).catch(err => {
                        this.$message.error(err.msg);
                    })

                if(data!=4&&data!=5){
                    this.showdialog = true;
                    if (data == 1) {
                        this.editstate = '新增婚庆';
                        this.getdownPayment();
                    }
                    if (data == 2) {
                        this.editstate = '编辑婚庆';
                    }
                    if (data == 3) {
                        this.editstate = '查看';
                        if (wedid){
                            this.showWeddinginfo = true;
                        }
                    }

                }
                if(data==5){
                    var that=this;
                    this.$confirm('是否取消该婚庆订单?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        //wedid
                        that.$axios.post('wedding/cancelWeddingOrderByIds/',wedid).then(res=>{
                            that.$message.success('婚庆订单取消成功!');
                            that.getWeddingOrder();
                        }).catch(err=>{
                            that.$message.error(err.msg);

                        })
                    }).catch(() => {

                    });
                }
                if(wedid){
                    this.$axios.get('/wedding/orderWeddingDetail/'+wedid).then(res => {
                        console.log('婚庆信息',res)
                        var weddingData=res.data;
                        weddingData.extraTree={
                            itemsExTree:weddingData.extra
                        }
                        weddingData.weddingPackage={
                            packageTypeCode:weddingData.weddingPackageId
                        };
                        weddingData.orderMoney=weddingData.weddingMoney;
                        if(data==4){
                            var content='',packageContent='',orderExtraContent='';
                            console.log(weddingData)
                            for(var i in weddingData.weddingItemsExs){
                                packageContent +=weddingData.weddingItemsExs[i].itemName+'、';
                            }
                            if(packageContent.substring(packageContent.length-1,packageContent.length)=='、'){
                                weddingData.packageContent=packageContent.substring(0,packageContent.length-1)
                            }
                            for(var i in weddingData.extra){
                                orderExtraContent +=weddingData.extra[i].itemName+':'+weddingData.extra[i].itemPrice+'*'+weddingData.extra[i].itemCount+'、';
                            }
                            if(orderExtraContent.substring(orderExtraContent.length-1,orderExtraContent.length)=='、'){
                                weddingData.orderExtraContent=orderExtraContent.substring(0,orderExtraContent.length-1)
                            }
                            content='新郎姓名：'+weddingData.maleName+'\n' +
                                '新娘姓名：'+weddingData.femaleName+'\n' +
                                '手机号码：'+(weddingData.phoneMale||'无')+'\n' +
                                '其他手机：'+(weddingData.phoneFemale||'无')+'\n' +
                                '典礼时间：'+weddingData.weddingBeginTime+'\n' +
                                '套餐名称：'+(weddingData.weddingPackageName||'未选')+'\n' +
                                (weddingData.packageContent ? ('         （'+weddingData.packageContent+'）\n'):'') +
                                '增加项目：'+(weddingData.exItemMoney||0)+'\n' +
                                (weddingData.orderExtraContent ? ('         （'+weddingData.orderExtraContent+'）\n'):'') +
                                '婚庆共计：'+weddingData.orderMoney+'\n' +
                                '婚庆订金：'+weddingData.downPayment+'\n' +
                                '接待人员：'+weddingData.createUserName+'\n' +
                                '接待电话：' + (weddingData.createUserPhone || '无') + '\n' +
                                '下单日期：'+weddingData.createTime+'\n' +
                                '订单备注：'+(weddingData.remark||'无')+'\n';
                            this.$copyText(content).then((e)=> {
                                this.$message.success('已复制到剪贴板');
                                console.log(e)
                            }, (err)=> {
                                this.$message.success('复制失败');
                                console.log(err)
                            })
                        }
                        this.weddingData=weddingData;
                        this.wedinfo = res.data;
                    }).catch(err => {
                        this.$message.error(err.msg);
                    })
                }else{
                    this.weddingData.extraTree={
                        itemsExTree:[]
                    }
                }
            },
            lookextra() {
                this.showextra = true;
            },
            getTotal(data) {
                console.log(this.weddingData.extra)
                this.weddingData.exItemMoney = data.nowPrice;
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.getWeddingOrder();
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getWeddingOrder();
                console.log(`当前页: ${val}`);
            },
        },
    }
</script>

<style scoped lang="scss">
    .weddingrecords {
        .content1 {
            .textnowrap {
                font-size: 13px;
                color: #333;
            }
            .date {
                min-width: 100px;
            }
        }
        .doedit {
            .el-divider__text {
                font-weight: 700 !important;
                color: #5295e7;
            }
        }
    }
</style>